import React from "react";
import { connect } from "react-redux";
import SignIn from "../SignIn";
import SurveyResultsContainer from "./SurveyResultsContainer";
import { signInUser } from "../../modules/user/actions";

class SurveyResultsHOCContainer extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    if (!this.props.user) {
      return (
        <SignIn
          submitting={this.props.submitting}
          errorMessage={this.props.errorMessage}
          signInUser={this.props.signInUser}
        />
      );
    }
    return <SurveyResultsContainer />;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    submitting: state.user.submitting,
    errorMessage: state.user.error
  };
}

const mapActionsToProps = {
  signInUser
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(SurveyResultsHOCContainer);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/container.js